import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import styled from 'styled-components';
import { getBackgroundColor } from '@magalu/stereo-ui-styles';
import { Flex } from '@magalu/stereo-ui/atoms';
export var ListItem = styled.li(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &:focus {\n    outline: 2px solid ", ";\n    outline-offset: 2px;\n  }\n"])), getBackgroundColor('opacityBlue'));
export var Root = styled(Flex)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: 100%;\n"])));